var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.9,118.3c0,5.4,3.1,9.9,6.9,9.9H61c2.1-6.9,4.9-13.5,8.3-19.8H53.8C50,108.4,46.9,112.8,46.9,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,157.7h2.3c0.2-6.8,1-13.4,2.4-19.8h-4.7c-3.8,0-6.9,4.4-6.9,9.9S50,157.7,53.8,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,187.2H59c-1.5-6.4-2.4-13-2.8-19.8h-2.4c-3.8,0-6.9,4.4-6.9,9.9C46.9,182.7,50,187.2,53.8,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.5,226.3H37c-10.1,0-9.8-9.8-9.8-9.8V59.2c0,0-0.4-9.8,9.8-9.8c5.2,0,2.7,0,9.8,0v9.8 c0,0.8,0.4,9.8,9.8,9.8h47.9c12.1-8.4,26-14.5,40.9-17.6c0-0.6,0-1.3,0-2.1c11.6,0,9.5,0.1,9.5,0.1s0.7,0,1.8,0.2 c3.9-0.4,7.8-0.6,11.8-0.6c5.1,0,10.1,0.3,15,1c-3.1-13.3-13.2-20.3-28.5-20.3h-9.8c0,0.1,0-6.3,0-9.8c0-0.1-0.3-9.8-9.8-9.8H56.6 c-9.6,0-9.8,10.3-9.8,9.8v9.8c-6.4,0-9.8,0-9.8,0C17.5,29.7,7.5,40,7.5,59.2v157.3c0,19.2,9.9,29.5,29.5,29.5h57.2 C87.6,240.2,81.6,233.5,76.5,226.3z M66.5,29.7h59v19.7h-59V29.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.3,107.4c-4.3-5.3-9.3-10.4-14.9-14.7c-5.5-4.3-11.3-7.8-17.7-10.8c-1.2-0.5-2.3-1.1-3.4-1.5 c-10-4.1-21-6.4-32.6-6.4h-1.5c-47.8,0-86.8,38.8-86.8,86.8v1.5c0,47.8,38.8,86.8,86.8,86.8h1.5c47.8,0,86.8-38.8,86.8-86.8v-1.5 C255.6,140.7,248.7,122.1,237.3,107.4z M234.7,173.7h-52.2v52.2h-24.4c-0.1,0.1-0.1-52.2-0.1-52.2h-52.2v-24.4h52.2V97.1h24.4v52.2 h52.3V173.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBooking);
export default __webpack_public_path__ + "static/media/create_booking.248ea6b6f072677fec8c4ad53e25411a.svg";
export { ForwardRef as ReactComponent };